import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVisionProApp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconVisionProApp"><Path fillRule="evenodd" clipRule="evenodd" d="M3 4H23V18H20V20H6V18H3V4ZM18 17H8V18H18V17ZM2 8V14H0V8H2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVisionProApp;
